import * as React from "react";
import { Segment } from "semantic-ui-react";

/* Displays an error page in case user navigates to some weird place */
const ErrorPage = (): JSX.Element => (
  <Segment className="container-with-bg">
    <h1 className="header">Error 404!</h1>
    <div className="header">
      You tried to navigate to a page that doesn't exist. If this problem persists or you think
      there might be a problem in the application please contact the adminstrator.
    </div>
  </Segment>
);

export default ErrorPage;
